import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../globalFunctions';
import { UsersRegistersReportFilters } from '../routes/LogicManager/LogicManagerReportRoute/types';

export class ReportDAO {
    static async getData(
        token: string,
        navigate: NavigateFunction,
        filters: UsersRegistersReportFilters
    ) {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/report/users.registers`,
                filters,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao carregar relatório',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
